import styled from 'styled-components'
import { default as VARIABLES } from '../../themes/styles/variables'
import { ICONS } from '../../themes'

// Wrapper
// ============================================================
export const SupplierManagementAdminStyled = styled.div`
  /* Parent styles
  ------------------------------- */
  width: 100%;

  /* Child element styles
  ------------------------------- */
  /* .main-content {
    min-width: 1600px;
  } */

  .table-wrapper {
    margin-top: 21px;
  }

  .table {
    .table-row {
      .company-name {
        flex: 1 1 auto;
        min-width: 150px;
      }

      .main-directory {
        flex: 0 0 11%;
        justify-content: center;
        text-align: center;
      }

      .status {
        flex: 0 0 14%;
      }

      .sustainability-pre-assessment {
        flex: 0 0 12%;
        justify-content: center;
        text-align: center;

        /* hide */
      }

      .active {
        flex: 0 0 9%;
        justify-content: center;
        text-align: center;
      }

      .actions {
        flex: 0 0 12%;
      }
    }
  }

  /* Modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
`

export const SupplierManagementBuyerStyled = styled.div`
  /* Parent styles
  ------------------------------- */
  width: 100%;

  /* Child element styles
  ------------------------------- */
  /* .main-content {
    min-width: 1600px;
  } */
.table-responsive {
  width: 100%;
   /* width */
   ::-webkit-scrollbar {
      width: 5px;
      height: 10px;
    }
  
    /* Track */
    ::-webkit-scrollbar-track {
      background: ${VARIABLES.COLORS.GRAY_2};
      border-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
    }
  
    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: ${VARIABLES.COLORS.BLUE_4};
      border-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
    }
  
    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: ${VARIABLES.COLORS.BLUE_1};
    }
}
  .table-supplier {
    /* max-width: 1250px; */
  }


  .table {
    .table-row {
      .tax-id {
      }
      .company-name {
        flex: 1 1 auto;
        min-width: 150px;
      }
      .branch {
        flex: 0 0 11%;
      }
      .offline-comprehensive {
        flex: 0 0 16%;
        min-width: 235px;
      }
      .status{
        flex: 0 0 16%;
        min-width: 220px;
      }
      .register-date {
        flex: 0 0 14%;
      }
      .actions {
        flex: 0 0 12%;
        min-width: 160px;
      }
    }
  }

  /* .table {
    .table-row {
      .company-name {
        flex: 1 1 auto;
        min-width: 150px;
      }

      .branch-number {
        flex: 0 0 11%;
        justify-content: center;
        text-align: center;
      }

      .offline-comprehensive-assessment-score {
        flex: 0 0 16%;
        justify-content: center;
        text-align: center;
        min-width: 235px;
      }

      .status {
        flex: 0 0 14%;
      }

      .registered-date {
        flex: 0 0 15%;
        text-align: center;
        justify-content: center;
      }

      .actions {
        flex: 0 0 12%;
      }
    }
  } */

  .contact-modal {
    /* .header-info {
      width: 100%;
    }

    .info-outer-wrapper {
      width: 100%;
    }

    .info-wrapper {
      flex-wrap: wrap;
    }

    .group-with-scoreboard {
      gap: 15px;

      .detail-groups {
        flex-direction: column;
      }
    }

    .data-control {
      display: flex;
      gap: 10px;
      align-items: flex-start;

      a {
        text-decoration: underline;
        font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_MEDIUM};
        color: ${VARIABLES.COLORS.BLUE_2};
      }
    } */

    .contact-person-wrapper {
      margin-bottom: 10px;
      flex-wrap: wrap;
      align-items: center;
      .full-name,.phone,.mail{
        padding-right: 10px;
        white-space: nowrap; 
        overflow: hidden;
        text-overflow: ellipsis; 
      }
      .full-name {
        width:280px;
        max-width:280px;
      }
      .phone{
        width:200px;
        max-width:200px;
      }
      .mail{
        width:350px;
        max-width:350px;
      }
    }

    .detail-groups {
      flex-direction: column;
    }

    .detail-group {
      margin-bottom: 15px;
      color: ${VARIABLES.COLORS.BLUE_1};

      > .label {
        flex: 0 0 220px;
        max-width: 220px;
        padding-right: 2rem;
        text-align: right;
        font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_MEDIUM};
      }

      .status {
        border-radius: ${VARIABLES.BORDER_RADIUSES.MD};
        font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.TN};
        display: flex;
        flex: none;
        padding: 0 14px;
        align-items: center;
        height: 24px;

        &.registration-status {
          border: 1px solid ${VARIABLES.COLORS.GRAY_15};
          color: ${VARIABLES.COLORS.GRAY_15};
        }

        &.active-status {
          border: 1px solid ${VARIABLES.COLORS.GREEN_1};
          color: ${VARIABLES.COLORS.GREEN_1};
        }

        &.not-regis-status {
          border: 1px solid ${VARIABLES.COLORS.GRAY_15};
          color: ${VARIABLES.COLORS.GRAY_15};
        }

        &.wait-active-status {
          border: 1px solid ${VARIABLES.COLORS.YELLOW_1};
          color: ${VARIABLES.COLORS.YELLOW_1};
        }
      }

      .data-control {
        .data {
          a {
            color: #6c63ff;
            margin-bottom: 10px;
          }
          .table {
            &.contact-detail {
              margin-top: -12px;

              .table-column {
                color: ${VARIABLES.COLORS.BLUE_1};
              }

              .full-name {
                max-width: calc(((100% - 200px) / 2) + 25px);
                /* min-width: 270px; */
              }

              .phone {
                max-width: 200px;
                /* min-width: 165px; */
              }

              .email {
                max-width: calc(((100% - 200px) / 2) - 25px);
                /* min-width: 270px; */
              }
            }
          }
        }
      }

      .file-link {
        background-color: ${VARIABLES.COLORS.GRAY_7};
        border: 1px solid ${VARIABLES.COLORS.GRAY_2};
        display: flex;
        align-items: center;
        padding: 7px 17px 7px 42px;
        width: 100%;
        border-radius: 6px;
        text-decoration: none;
        position: relative;
        margin-right: 10px;
        cursor: pointer;

        &:before {
          content: '';
          display: inline-block;
          background-image: url(${ICONS['icon-download-file.png']});
          width: 13px;
          height: 16px;
          margin-right: 15px;
          position: absolute;
          top: 50%;
          left: 19px;
          transform: translateY(-50%);
        }
      }
    }

    .actions {
      margin-left: 5%;
      flex: 0 0 231px;
      flex-wrap: wrap;
      align-content: flex-start;

      .button {
        margin-bottom: 10px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  /* Modifiers
  ------------------------------- */

  /* For noolek when merge srm to dev plz delete it!!!!
  ------------------------------- */

  .table-row {
    &:nth-child(2n) {
      .table-column {
        background-color: ${VARIABLES.COLORS.GRAY_7};
      }
    }
  }

  .w-100 {
    flex: 0 0 100px;
    max-width: 100px;
  }

  .w-150 {
    flex: 0 0 150px;
    max-width: 150px;
  }

  .w-180 {
    flex: 0 0 180px;
    max-width: 180px;
  }

  .w-200 {
    flex: 0 0 250px;
    max-width: 250px;
  }

  .w-250 {
    flex: 0 0 250px;
    max-width: 250px;
  }

  .text-center {
    justify-content: center;
  }

  .actions {
    display: flex;
    padding: 11px 8px 9px;

    > .section {
      margin-left: -3px;
      margin-right: -3px;
    }
  }

  /* Media queries
  ------------------------------- */
  @media all and (min-width: 1600.98px) {
    .content-body:has(#filter_search_input:focus) {
      .tbody {
        .table-column {
          div {
            color: #06304f;
          }
        }
      }
    }
  }

  @media all and (max-width: 1600.98px) {
    .table {
      .table-row {
        .offline-comprehensive-assessment-score {
          min-width: 225px;
        }
      }
    }
  }

  @media all and (max-width: 1440.98px) {
    .table {
      .table-row {
        .offline-comprehensive-assessment-score {
          min-width: 215px;
        }
      }
    }
  }

  @media all and (max-width: 1366.98px) {
    .table {
      .table-row {
        .offline-comprehensive-assessment-score {
          min-width: 205px;
        }
      }
    }
  }

  @media all and (max-width: 1280.98px) {
    .table {
      .table-row {
        .offline-comprehensive-assessment-score {
          min-width: 195px;
        }
      }
    }
  }

  @media all and (max-width: 1024.98px) {
    .table {
      .table-row {
        .offline-comprehensive-assessment-score {
          min-width: 185px;
        }
      }
    }
  }
`
